<lib-dialog
  personDialogModal="dialog"
  yesText="{{ yesText }}"
  header="{{ headerText }}"
>
  <ng-template>
    <div class="search-container">
      <mat-form-field floatLabel="always" appearance="outline" fxFlex>
        <div fxLayout="row">
          <mat-icon aria-label="Search" class="search-icon">search</mat-icon>
          <input
            type="text"
            placeholder="search by name or email"
            aria-label="search by name or email"
            matInput
            [formControl]="formControl"
            [matAutocomplete]="auto"
          />
        </div>
        @if (selectedProfile) {
          <button
            matSuffix
            mat-icon-button
            aria-label="Clear"
            (click)="clearSelection()"
          >
            <mat-icon>close</mat-icon>
          </button>
        }
        <mat-autocomplete
          #auto="matAutocomplete"
          (optionSelected)="onSelected($event)"
          [panelWidth]="500"
          [displayWith]="displayWith"
        >
          @if (isLoading) {
            <mat-option class="is-loading">Loading...</mat-option>
          }
          @if (!isLoading) {
            @for (profile of profiles; track profile) {
              <mat-option [value]="profile">
                <span>{{ profile.fullName }} ({{ profile.email }})</span>
              </mat-option>
            }
          }
        </mat-autocomplete>
      </mat-form-field>
    </div>
  </ng-template>
</lib-dialog>
